export enum InstallMeterStep {
  InstallationTechnology = 1,
  SensorScan,
  SensorConnection,
  Hardwares,
  InstallationDetail,
  Photo,
  Review,
}
